import ImpersonationWarning from './ImpersonationWarning';
import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
export function SpaRecoveryPanel() {
  return (
    <Card sx={{ maxWidth: 720, mx: 'auto', my: 4 }}>
      <CardContent>
        <Stack spacing={3}>
          <ImpersonationWarning />
          <Typography component="h1" variant="h4">
            The application could not open
          </Typography>
          <Typography>Reload the page to try again. You can also continue to account sign-in.</Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Button variant="contained" onClick={() => window.location.reload()}>
              Reload page
            </Button>
            <Button component="a" href="/accounts/login/?spa=0" variant="outlined">
              Account sign-in
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
